module.exports = __webpack_public_path__ + "img/slide21-tronic.e2bed20c.png";